// Produtos Zebra e Extreme com especificações técnicas

// Importando os módulos
import {
  initProductGalleries,
  changeProductImage,
  selectProductImage,
} from "./modules/gallery.js";
import {
  openBudgetModal,
  closeBudgetModal,
  closeBudgetModalOnOverlay,
  toggleProductSelection,
  updateQuantity,
  setQuantity,
  handleBudgetSubmit,
  updateBudgetCartBadge,
} from "./modules/budget.js";
import { initAllUIEnhancements } from "./modules/ui-enhancements.js";
import { initWhatsAppMenu } from "./modules/whatsapp.js";
import { initCarousel } from "./modules/carousel.js";

// Inicializar módulos extraídos
document.addEventListener("DOMContentLoaded", () => {
  initAllUIEnhancements();
  initWhatsAppMenu();
  initCarousel();
});

// Mapeamento de thumbnails dos produtos para uso uniforme
export const PRODUCT_THUMBS = {
  ZT411: "assets/img/products/thumb/ZT411.png",
  ZD421: "assets/img/products/thumb/ZD421.png",
  ZT610: "assets/img/products/thumb/ZT610.png",
  ZT231: "assets/img/products/thumb/ZT231.png",
  ZD510: "assets/img/products/thumb/ZD510-1.png",
  ZD621: "assets/img/products/thumb/ZD621.png",
  ZQ630: "assets/img/products/thumb/ZQ630.png",
  TC22: "assets/img/products/thumb/TC22.png",
  TC58: "assets/img/products/thumb/TC58.png",
  TC52: "assets/img/products/thumb/TC22.png",
  TC57: "assets/img/products/thumb/TC58.png",
  MC34: "assets/img/products/thumb/MC34.png",
  MC3300: "assets/img/products/thumb/MC33.png",
  MC9300: "assets/img/products/thumb/MC93.png",
  DS2208: "assets/img/products/thumb/DS2208-1.png",
  DS8178: "assets/img/products/thumb/DS8178-1.png",
  DS9308: "assets/img/products/thumb/DS9308-1.png",
  DS3608: "assets/img/products/thumb/DS3608.png",
  DS457: "assets/img/products/thumb/DS457.png",
  DS2278: "assets/img/products/thumb/ds2278.png",
  ET40: "assets/img/products/thumb/ET40.png",
  ET45: "assets/img/products/thumb/ET45.png",
  L10: "assets/img/products/thumb/L10.png",
  WT6300: "assets/img/products/thumb/WT6300.png",
  RS6100: "assets/img/products/thumb/RS6100.png",
  WS50: "assets/img/products/thumb/WS50.png",
  AP4000: "assets/img/products/thumb/AP4000.png",
  AP5010: "assets/img/products/thumb/AP5010.png",
  AP3000: "assets/img/products/thumb/AP3000.png",
  AP305C: "assets/img/products/thumb/AP305C.png",
  "ExtremeCloud IQ": "assets/img/products/thumb/AP4000.png",
};

// Função para obter thumbnail do produto
export function getProductThumb(productName) {
  return PRODUCT_THUMBS[productName] || null;
}

// Auto-detect asset base path (supports loading from subdirectories like V2/)
const ASSET_BASE = (function () {
  if (typeof window.YTECH_ASSET_BASE === "string")
    return window.YTECH_ASSET_BASE;
  try {
    const scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      const src = scripts[i].getAttribute("src") || "";
      if (src.includes("app.js") && src.startsWith("../")) return "../";
    }
  } catch (e) {}
  return "";
})();
export function assetPath(p) {
  if (
    !p ||
    p.startsWith("http") ||
    p.startsWith("//") ||
    p.startsWith("data:") ||
    p.startsWith("../")
  )
    return p;
  return ASSET_BASE + p;
}

// Dados de produtos carregados do JSON (lazy-load)
export let productsData = {};
export let productsLoaded = false;

export async function loadProductsData() {
  if (productsLoaded) return productsData;
  try {
    const response = await fetch(assetPath("assets/data/products.json"));
    if (!response.ok) throw new Error("HTTP " + response.status);
    productsData = await response.json();
    productsLoaded = true;
  } catch (err) {
    console.error("[Ytech] Erro ao carregar produtos:", err);
    productsData = {};
  }
  return productsData;
}

// Pre-carregar dados quando a p�gina ficar ociosa
if ("requestIdleCallback" in window) {
  requestIdleCallback(() => loadProductsData());
} else {
  setTimeout(() => loadProductsData(), 1000);
}

// Usa dados de config.js se disponível
const _cfg =
  typeof window !== "undefined" &&
  window.SITE_CONFIG &&
  typeof window.SITE_CONFIG === "object"
    ? window.SITE_CONFIG
    : {};
const _apiCfg = _cfg.api && typeof _cfg.api === "object" ? _cfg.api : {};
const API_BASE_URL =
  typeof _apiCfg.baseUrl === "string" ? _apiCfg.baseUrl.replace(/\/$/, "") : "";
const API_TIMEOUT_MS = Number(_apiCfg.timeoutMs || 15000);
const TURNSTILE_SITE_KEY =
  typeof _apiCfg.turnstileSiteKey === "string"
    ? _apiCfg.turnstileSiteKey.trim()
    : "";
const turnstileState = {
  scriptPromise: null,
  widgets: new Map(),
};
const defaultConfig = {
  company_name: (_cfg.company && _cfg.company.name) || "Ytech Soluções",
  hero_title: "Transforme Seu Negócio com Tecnologia de Ponta",
  hero_subtitle:
    "Soluções completas Zebra e Extreme Networks em impressão térmica, captura de dados, identificação automática e infraestrutura de rede para impulsionar a eficiência operacional da sua empresa.",
  hero_cta_primary: "Solicitar Demonstração",
  hero_cta_secondary: "Explorar Soluções",
  about_title: "Parceiro Certificado Zebra e Extreme Networks",
  about_description:
    "A Ytech Soluções é referência nacional em tecnologia de identificação automática e infraestrutura de rede. Com certificações oficiais Zebra Technologies e Extreme Networks, oferecemos consultoria especializada, implementação profissional e suporte técnico de excelência para empresas que buscam otimizar seus processos e modernizar sua infraestrutura de TI.",
  contact_email:
    (_cfg.contact && _cfg.contact.email) || "jairo@ytechsolucoes.com",
  contact_phone: (_cfg.contact && _cfg.contact.phone) || "(92) 3307-0068",
  contact_address:
    (_cfg.contact && _cfg.contact.address) ||
    "Mirage Centro Comercial, Av. Desembargador João Machado nº 597 sala 04, Manaus - AM",
  primary_color: "#003366",
  background_color: "#f5f7fa",
  text_color: "#1a1a1a",
  accent_color: "#6c757d",
  surface_color: "#ffffff",
  font_family: "Inter",
  font_size: 16,
};

export function getApiUrl(path) {
  if (!path) return API_BASE_URL || "/";
  if (/^https?:\/\//i.test(path)) return path;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return API_BASE_URL ? `${API_BASE_URL}${normalizedPath}` : normalizedPath;
}

export async function postJson(path, payload) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), API_TIMEOUT_MS);

  try {
    const response = await fetch(getApiUrl(path), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(data.error || "Não foi possível concluir a solicitação.");
    }

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      throw new Error("Tempo de resposta excedido. Tente novamente.");
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function isTurnstileEnabled() {
  return Boolean(TURNSTILE_SITE_KEY);
}

function ensureTurnstileScript() {
  if (!isTurnstileEnabled()) return Promise.resolve(null);
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (turnstileState.scriptPromise) return turnstileState.scriptPromise;

  turnstileState.scriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      'script[data-ytech-turnstile="true"]',
    );
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.turnstile));
      existingScript.addEventListener("error", () =>
        reject(new Error("Não foi possível carregar a proteção anti-bot.")),
      );
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.dataset.ytechTurnstile = "true";
    script.onload = () => resolve(window.turnstile);
    script.onerror = () =>
      reject(new Error("Não foi possível carregar a proteção anti-bot."));
    document.head.appendChild(script);
  });

  return turnstileState.scriptPromise;
}

export async function renderTurnstileWidget(formName, containerId, messageId) {
  if (!isTurnstileEnabled()) return null;

  const container = document.getElementById(containerId);
  if (!container || turnstileState.widgets.has(formName)) {
    return turnstileState.widgets.get(formName) || null;
  }

  const turnstile = await ensureTurnstileScript();
  if (!turnstile) return null;

  const widgetId = turnstile.render(container, {
    sitekey: TURNSTILE_SITE_KEY,
    theme: "light",
    callback: () => {
      const messageEl = document.getElementById(messageId);
      if (messageEl) {
        messageEl.textContent = "";
        messageEl.style.display = "none";
      }
    },
    "expired-callback": () => {
      const messageEl = document.getElementById(messageId);
      if (messageEl) {
        messageEl.textContent =
          "A verificação anti-bot expirou. Confirme novamente.";
        messageEl.className = "form-message error";
        messageEl.style.display = "block";
      }
    },
  });

  turnstileState.widgets.set(formName, widgetId);
  return widgetId;
}

export function getTurnstileToken(formName) {
  if (!isTurnstileEnabled() || !window.turnstile) return "";
  const widgetId = turnstileState.widgets.get(formName);
  if (widgetId === undefined) return "";
  return window.turnstile.getResponse(widgetId) || "";
}

export function resetTurnstileWidget(formName) {
  if (!isTurnstileEnabled() || !window.turnstile) return;
  const widgetId = turnstileState.widgets.get(formName);
  if (widgetId !== undefined) {
    window.turnstile.reset(widgetId);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (!isTurnstileEnabled()) return;
  renderTurnstileWidget(
    "contact",
    "contactTurnstile",
    "contactTurnstileMessage",
  ).catch(() => {});
  renderTurnstileWidget(
    "budget",
    "budgetTurnstile",
    "budgetTurnstileMessage",
  ).catch(() => {});
});

async function onConfigChange(config) {
  const companyName = config.company_name || defaultConfig.company_name;
  const heroTitle = config.hero_title || defaultConfig.hero_title;
  const heroSubtitle = config.hero_subtitle || defaultConfig.hero_subtitle;
  const heroCtaPrimary =
    config.hero_cta_primary || defaultConfig.hero_cta_primary;
  const heroCtaSecondary =
    config.hero_cta_secondary || defaultConfig.hero_cta_secondary;
  const aboutTitle = config.about_title || defaultConfig.about_title;
  const aboutDescription =
    config.about_description || defaultConfig.about_description;
  const contactEmail = config.contact_email || defaultConfig.contact_email;
  const contactPhone = config.contact_phone || defaultConfig.contact_phone;
  const contactAddress =
    config.contact_address || defaultConfig.contact_address;

  const primaryColor = config.primary_color || defaultConfig.primary_color;
  const backgroundColor =
    config.background_color || defaultConfig.background_color;
  const textColor = config.text_color || defaultConfig.text_color;
  const accentColor = config.accent_color || defaultConfig.accent_color;
  const surfaceColor = config.surface_color || defaultConfig.surface_color;

  const customFont = config.font_family || defaultConfig.font_family;
  const baseFontSize = config.font_size || defaultConfig.font_size;
  const baseFontStack =
    "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif";

  document.getElementById("company-name").textContent = companyName;
  document.getElementById("hero-title").innerHTML = heroTitle.replace(
    "Tecnologia Zebra",
    '<span class="hero-highlight">Tecnologia Zebra</span>',
  );
  document.getElementById("hero-subtitle").textContent = heroSubtitle;
  document.getElementById("hero-cta-primary").textContent = heroCtaPrimary;
  document.getElementById("hero-cta-secondary").textContent = heroCtaSecondary;
  document.getElementById("about-title").textContent = aboutTitle;
  document.getElementById("about-description").textContent = aboutDescription;
  document.getElementById("contact-email").textContent = contactEmail;
  document.getElementById("contact-phone").textContent = contactPhone;
  document.getElementById("contact-address").textContent = contactAddress;

  const logoEl = document.querySelector(".logo");
  if (logoEl) logoEl.style.color = primaryColor;
  const logoIconEl = document.querySelector(".logo-icon");
  if (logoIconEl)
    logoIconEl.style.background = `linear-gradient(135deg, ${primaryColor} 0%, ${adjustColor(primaryColor, 20)} 100%)`;
  document.querySelector(".hero").style.background =
    `linear-gradient(135deg, ${primaryColor} 0%, ${adjustColor(primaryColor, 10)} 50%, ${adjustColor(primaryColor, 30)} 100%)`;
  document.querySelector(".cta-section").style.background =
    `linear-gradient(135deg, ${primaryColor} 0%, ${adjustColor(primaryColor, 10)} 100%)`;
  document.querySelector("footer").style.background = primaryColor;

  document.querySelectorAll(".nav-cta").forEach((el) => {
    el.style.background = primaryColor;
  });

  document.querySelectorAll(".contact-item-icon").forEach((el) => {
    el.style.background = primaryColor;
  });

  document.querySelector(".form-submit").style.background = primaryColor;

  document.querySelectorAll(".section-header h2").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".solution-card h3").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".industry-card h4").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".about-content h2").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".contact-info h3").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".contact-item-content p").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".stat-box h3").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".testimonial-info h4").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelectorAll(".solution-link").forEach((el) => {
    el.style.color = primaryColor;
  });

  document.querySelector(".about-image").style.background =
    `linear-gradient(135deg, ${primaryColor} 0%, ${adjustColor(primaryColor, 30)} 100%)`;

  document.querySelector(".testimonial-avatar").style.background =
    `linear-gradient(135deg, ${primaryColor} 0%, ${adjustColor(primaryColor, 20)} 100%)`;

  document.querySelectorAll(".stat-box").forEach((el) => {
    el.style.background = backgroundColor;
  });

  document.querySelector(".trusted-by").style.background = backgroundColor;
  document.querySelector(".industries").style.background = backgroundColor;

  document.querySelectorAll(".contact-item").forEach((el) => {
    el.style.background = backgroundColor;
  });

  document.querySelector(".contact-form").style.background = backgroundColor;

  document.body.style.color = textColor;

  document.querySelectorAll(".section-label").forEach((el) => {
    el.style.color = accentColor;
  });

  document
    .querySelectorAll(".solution-card, .industry-card, .testimonial-card")
    .forEach((el) => {
      el.style.background = surfaceColor;
    });

  document.body.style.fontFamily = `${customFont}, ${baseFontStack}`;

  document.querySelector(".hero h1").style.fontSize = `${baseFontSize * 4}px`;
  document.querySelector(".hero p").style.fontSize = `${baseFontSize * 1.25}px`;
  document.querySelectorAll(".section-header h2").forEach((el) => {
    el.style.fontSize = `${baseFontSize * 3}px`;
  });
  document.querySelectorAll(".solution-card h3").forEach((el) => {
    el.style.fontSize = `${baseFontSize * 1.5}px`;
  });
  document.querySelectorAll(".solution-card p").forEach((el) => {
    el.style.fontSize = `${baseFontSize}px`;
  });
}

// Hero random product flyers
const heroFlyerImages = [
  { src: "assets/img/products/thumb/ZT411.png", name: "ZT411", isAP: false },
  { src: "assets/img/products/thumb/ZD421.png", name: "ZD421", isAP: false },
  { src: "assets/img/products/thumb/ZT610.png", name: "ZT610", isAP: false },
  { src: "assets/img/products/thumb/ZT231.png", name: "ZT231", isAP: false },
  { src: "assets/img/products/thumb/ZD510-1.png", name: "ZD510", isAP: false },
  { src: "assets/img/products/thumb/TC22.png", name: "TC22", isAP: false },
  { src: "assets/img/products/thumb/TC58.png", name: "TC58", isAP: false },
  { src: "assets/img/products/thumb/MC34.png", name: "MC34", isAP: false },
  { src: "assets/img/products/thumb/MC33.png", name: "MC33", isAP: false },
  { src: "assets/img/products/thumb/MC93.png", name: "MC93", isAP: false },
  {
    src: "assets/img/products/thumb/DS2208-1.png",
    name: "DS2208",
    isAP: false,
  },
  {
    src: "assets/img/products/thumb/DS8178-1.png",
    name: "DS8178",
    isAP: false,
  },
  {
    src: "assets/img/products/thumb/DS9308-1.png",
    name: "DS9308",
    isAP: false,
  },
  { src: "assets/img/products/thumb/DS3608.png", name: "DS3608", isAP: false },
  { src: "assets/img/products/thumb/DS457.png", name: "DS457", isAP: false },
  { src: "assets/img/products/thumb/ZD621.png", name: "ZD621", isAP: false },
  { src: "assets/img/products/thumb/ET40.png", name: "ET40", isAP: false },
  { src: "assets/img/products/thumb/ET45.png", name: "ET45", isAP: false },
  { src: "assets/img/products/thumb/L10.png", name: "L10", isAP: false },
  { src: "assets/img/products/thumb/ZQ630.png", name: "ZQ630", isAP: false },
  { src: "assets/img/products/thumb/AP4000.png", name: "AP4000", isAP: true },
  { src: "assets/img/products/thumb/AP5010.png", name: "AP5010", isAP: true },
  { src: "assets/img/products/thumb/AP3000.png", name: "AP3000", isAP: true },
  { src: "assets/img/products/thumb/AP305C.png", name: "AP305C", isAP: true },
];

function spawnHeroFlyer() {
  return new Promise((resolve) => {
    const layer = document.getElementById("hero-flyer-layer");
    if (!layer) return resolve();

    const imgData =
      heroFlyerImages[Math.floor(Math.random() * heroFlyerImages.length)];
    const item = document.createElement("div");
    item.className = "hero-flyer-item";
    if (imgData.isAP) {
      item.classList.add("hero-flyer-item--ap");
    }
    const img = new Image();
    img.src = assetPath(imgData.src);
    img.alt = "";
    img.loading = "eager";
    item.appendChild(img);

    const label = document.createElement("div");
    label.className = "hero-flyer-label";
    label.textContent = imgData.name;
    item.appendChild(label);

    layer.appendChild(item);

    const layerW = layer.clientWidth;
    const layerH = layer.clientHeight;

    // Ensure we can measure the item (after it is in DOM)
    requestAnimationFrame(() => {
      const itemW = item.clientWidth;
      const itemH = item.clientHeight;

      // Start centered
      const startLeft = (layerW - itemW) / 2;
      const startTop = (layerH - itemH) / 2;
      item.style.left = startLeft + "px";
      item.style.top = startTop + "px";

      // Pick a random direction and distance proportional to container
      const distance = Math.min(layerW, layerH) * (0.35 + Math.random() * 0.15); // 35%–50%
      const directions = [
        { x: 0, y: -1 }, // up
        { x: 0, y: 1 }, // down
        { x: -1, y: 0 }, // left
        { x: 1, y: 0 }, // right
      ];
      const dir = directions[Math.floor(Math.random() * directions.length)];
      let dx = dir.x * distance;
      let dy = dir.y * distance;

      // Clamp so it remains inside bounds (with 16px padding)
      const pad = 16;
      dx = Math.max(
        -(startLeft - pad),
        Math.min(dx, layerW - itemW - startLeft - pad),
      );
      dy = Math.max(
        -(startTop - pad),
        Math.min(dy, layerH - itemH - startTop - pad),
      );

      const duration = 8000 + Math.random() * 4000; // 8s–12s, mais devagar

      const animation = item.animate(
        [
          { opacity: 0, left: startLeft + "px", top: startTop + "px" },
          { opacity: 1, offset: 0.1 },
          {
            opacity: 1,
            left: startLeft + dx + "px",
            top: startTop + dy + "px",
            offset: 0.9,
          },
          {
            opacity: 0,
            left: startLeft + dx + "px",
            top: startTop + dy + "px",
          },
        ],
        {
          duration,
          easing: "ease-in-out",
          fill: "forwards",
        },
      );

      animation.onfinish = () => {
        item.remove();
        resolve();
      };
    });
  });
}

function startHeroFlyersSequential() {
  const loop = () => {
    spawnHeroFlyer().then(() => setTimeout(loop, 600)); // pequena pausa entre itens
  };
  loop();
}

document.addEventListener("DOMContentLoaded", startHeroFlyersSequential);

// Random category icons (usando thumbnails para performance mobile)
function setRandomCategoryIcons() {
  const thermalImages = [
    "assets/img/products/thumb/ZT411.png",
    "assets/img/products/thumb/ZD421.png",
    "assets/img/products/thumb/ZT610.png",
    "assets/img/products/thumb/ZT231.png",
    "assets/img/products/thumb/ZD510-1.png",
    "assets/img/products/thumb/ZD621.png",
    "assets/img/products/thumb/ZQ630.png",
  ];

  const mobileImages = [
    "assets/img/products/thumb/TC22.png",
    "assets/img/products/thumb/TC58.png",
    "assets/img/products/thumb/MC34.png",
    "assets/img/products/thumb/MC33.png",
    "assets/img/products/thumb/MC93.png",
  ];

  const scannersImages = [
    "assets/img/products/thumb/DS2208-1.png",
    "assets/img/products/thumb/DS8178-1.png",
    "assets/img/products/thumb/DS9308-1.png",
    "assets/img/products/thumb/DS3608.png",
    "assets/img/products/thumb/DS457.png",
  ];

  const tabletsImages = [
    "assets/img/products/thumb/ET40.png",
    "assets/img/products/thumb/ET45.png",
    "assets/img/products/thumb/L10.png",
  ];

  const wearablesImages = [
    "assets/img/products/thumb/WT6300.png",
    "assets/img/products/thumb/RS6100.png",
    "assets/img/products/thumb/WS50.png",
  ];

  const mobilePrintersImages = ["assets/img/products/thumb/ZQ630.png"];

  const extremeImages = [
    "assets/img/products/thumb/AP4000.png",
    "assets/img/products/thumb/AP5010.png",
    "assets/img/products/thumb/AP3000.png",
    "assets/img/products/thumb/AP305C.png",
  ];

  const thermalIcon = document.querySelector("#icon-thermal img");
  const mobileIcon = document.querySelector("#icon-mobile img");
  const scannersIcon = document.querySelector("#icon-scanners img");
  const tabletsIcon = document.querySelector("#icon-tablets img");
  const wearablesIcon = document.querySelector("#icon-wearables img");
  const mobilePrintersIcon = document.querySelector(
    "#icon-mobile-printers img",
  );
  const extremeIcon = document.querySelector("#icon-extreme img");

  if (thermalIcon) {
    thermalIcon.src = assetPath(
      thermalImages[Math.floor(Math.random() * thermalImages.length)],
    );
  }
  if (mobileIcon) {
    mobileIcon.src = assetPath(
      mobileImages[Math.floor(Math.random() * mobileImages.length)],
    );
  }
  if (scannersIcon) {
    scannersIcon.src = assetPath(
      scannersImages[Math.floor(Math.random() * scannersImages.length)],
    );
  }
  if (tabletsIcon) {
    tabletsIcon.src = assetPath(
      tabletsImages[Math.floor(Math.random() * tabletsImages.length)],
    );
  }
  if (wearablesIcon) {
    wearablesIcon.src = assetPath(
      wearablesImages[Math.floor(Math.random() * wearablesImages.length)],
    );
  }
  if (mobilePrintersIcon) {
    mobilePrintersIcon.src = assetPath(
      mobilePrintersImages[
        Math.floor(Math.random() * mobilePrintersImages.length)
      ],
    );
  }
  if (extremeIcon) {
    extremeIcon.src = assetPath(
      extremeImages[Math.floor(Math.random() * extremeImages.length)],
    );
  }
}

document.addEventListener("DOMContentLoaded", setRandomCategoryIcons);

function adjustColor(color, percent) {
  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.max(0, Math.min(255, (num >> 16) + amt));
  const G = Math.max(0, Math.min(255, ((num >> 8) & 0x00ff) + amt));
  const B = Math.max(0, Math.min(255, (num & 0x0000ff) + amt));
  return "#" + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
}

function scrollToSection(sectionId) {
  const section = document.getElementById(sectionId);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
}

function handleSubmit(event) {
  event.preventDefault();
  const messageEl = document.getElementById("formMessage");
  messageEl.textContent =
    "Mensagem enviada com sucesso! Nossa equipe entrará em contato em breve.";
  messageEl.className = "form-message success";
  messageEl.style.display = "block";
  document.getElementById("contactForm").reset();

  setTimeout(() => {
    messageEl.style.display = "none";
  }, 5000);
}

async function openProductModal(category, productName) {
  await loadProductsData();
  const data = productsData[category];
  if (!data) return;

  document.getElementById("modalTitle").textContent = data.title;
  document.getElementById("modalDescription").textContent = data.description;

  const productsList = document.getElementById("productsList");
  productsList.innerHTML = "";

  data.products.forEach((product) => {
    const specsList = Array.isArray(product.specs) ? product.specs : [];
    const featuresList = Array.isArray(product.features)
      ? product.features
      : [];

    const specsHTML = specsList.length
      ? `
        <div class="product-specs">
          ${specsList
            .map(
              (spec) => `
            <div class="spec-item">
              <div class="spec-icon">${spec.icon}</div>
              <div class="spec-content">
                <h4>${spec.title}</h4>
                <p>${spec.value}</p>
              </div>
            </div>
          `,
            )
            .join("")}
        </div>`
      : "";

    const featuresHTML = featuresList.length
      ? `
        <div class="product-features">
          <h4>Principais Características</h4>
          <div class="features-grid">
            ${featuresList
              .map(
                (feature) => `
              <div class="feature-tag">${feature}</div>
            `,
              )
              .join("")}
          </div>
        </div>`
      : "";

    const imageGalleryHTML =
      product.images && product.images.length > 1
        ? `
      <div class="product-gallery">
        <div class="gallery-main">
          <button class="gallery-nav gallery-prev" onclick="changeProductImage(event, -1)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          <img src="${assetPath(product.images[0])}" alt="${product.name}" class="gallery-main-image" loading="eager" draggable="false">
          <button class="gallery-nav gallery-next" onclick="changeProductImage(event, 1)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
        <div class="gallery-thumbnails">
          ${product.images
            .map(
              (img, index) => `
            <img src="${assetPath(img)}" alt="${product.name} - Imagem ${index + 1}" 
                 class="gallery-thumbnail ${index === 0 ? "active" : ""}" 
                 onclick="selectProductImage(event, ${index})" loading="eager">
          `,
            )
            .join("")}
        </div>
      </div>
    `
        : `
      <div class="product-icon-single">
        ${product.image ? `<img src="${assetPath(product.image)}" alt="${product.name}" loading="lazy" referrerpolicy="no-referrer" onerror="this.style.display='none'; this.parentElement.innerHTML='${product.icon}';">` : product.icon}
      </div>
    `;

    const productHTML = `
      <div class="product-item" data-product-name="${product.name}" data-images='${JSON.stringify((product.images || []).map((i) => assetPath(i)))}'>
        <div class="product-header">
          ${imageGalleryHTML}
          <div class="product-title">
            <h3>${product.name}</h3>
            <p>${product.subtitle}</p>
          </div>
        </div>
        ${specsHTML}
        ${featuresHTML}
        
        <div class="product-cta">
          <button class="btn-product-primary" onclick="closeProductModal(); openBudgetModal('${product.name}');">Solicitar Cotação</button>
          ${product.datasheet ? `<button class="btn-product-secondary" onclick="openPdfModal('${assetPath(product.datasheet)}', '${product.name}')">Ficha Técnica (PDF)</button>` : ""}
          ${
            product.view3d
              ? `<button class="btn-product-3d" onclick="window.open('${product.view3d}', '_blank', 'noopener,noreferrer')">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>
            Visualizar na ferramenta 3D
          </button>`
              : ""
          }
        </div>
      </div>
    `;
    productsList.innerHTML += productHTML;
  });

  document.getElementById("productModal").classList.add("active");
  // Lock body scroll for iOS
  window.modalScrollY = window.scrollY;
  document.body.style.top = `-${window.modalScrollY}px`;
  document.body.classList.add("modal-open");
  document.documentElement.classList.add("modal-open");
  initProductGalleries();

  // If a specific product was requested, scroll to it and highlight
  if (productName) {
    setTimeout(() => {
      const target = productsList.querySelector(`[data-product-name="${productName}"]`);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        target.style.transition = "box-shadow 0.4s, outline 0.4s";
        target.style.boxShadow = "0 0 0 3px rgba(0, 119, 204, 0.6)";
        target.style.outline = "2px solid rgba(0, 119, 204, 0.4)";
        target.style.borderRadius = "16px";
        setTimeout(() => {
          target.style.boxShadow = "";
          target.style.outline = "";
        }, 2500);
      }
    }, 300);
  }
}

function closeProductModal() {
  document.getElementById("productModal").classList.remove("active");
  // Restore body scroll for iOS
  document.body.classList.remove("modal-open");
  document.documentElement.classList.remove("modal-open");
  document.body.style.top = "";
  window.scrollTo(0, window.modalScrollY || 0);
}

function closeModalOnOverlay(event) {
  if (event.target.id === "productModal") {
    closeProductModal();
  }
}

// PDF Modal Functions - Versão com Leitor Nativo
function openPdfModal(pdfPath, productName) {
  const width = Math.min(1000, window.innerWidth * 0.8);
  const height = Math.min(800, window.innerHeight * 0.9);
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  window.open(
    assetPath(pdfPath),
    `pdf_${productName}`,
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,status=yes`,
  );
}

// Scroll animations
const observerOptions = {
  threshold: 0.1,
  rootMargin: "0px 0px -50px 0px",
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("visible");
    }
  });
}, observerOptions);

document.querySelectorAll(".fade-in").forEach((el) => {
  observer.observe(el);
});

// Header scroll effect
window.addEventListener("scroll", () => {
  const header = document.getElementById("header");
  if (window.scrollY > 50) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});

// SDK opcional
if (window.elementSdk) {
  window.elementSdk.init({
    defaultConfig,
    onConfigChange,
    mapToCapabilities: (config) => ({
      recolorables: [
        {
          get: () => config.primary_color || defaultConfig.primary_color,
          set: (value) => {
            config.primary_color = value;
            window.elementSdk.setConfig({ primary_color: value });
          },
        },
        {
          get: () => config.background_color || defaultConfig.background_color,
          set: (value) => {
            config.background_color = value;
            window.elementSdk.setConfig({ background_color: value });
          },
        },
        {
          get: () => config.text_color || defaultConfig.text_color,
          set: (value) => {
            config.text_color = value;
            window.elementSdk.setConfig({ text_color: value });
          },
        },
        {
          get: () => config.accent_color || defaultConfig.accent_color,
          set: (value) => {
            config.accent_color = value;
            window.elementSdk.setConfig({ accent_color: value });
          },
        },
        {
          get: () => config.surface_color || defaultConfig.surface_color,
          set: (value) => {
            config.surface_color = value;
            window.elementSdk.setConfig({ surface_color: value });
          },
        },
      ],
      borderables: [],
      fontEditable: {
        get: () => config.font_family || defaultConfig.font_family,
        set: (value) => {
          config.font_family = value;
          window.elementSdk.setConfig({ font_family: value });
        },
      },
      fontSizeable: {
        get: () => config.font_size || defaultConfig.font_size,
        set: (value) => {
          config.font_size = value;
          window.elementSdk.setConfig({ font_size: value });
        },
      },
    }),
    mapToEditPanelValues: (config) =>
      new Map([
        ["company_name", config.company_name || defaultConfig.company_name],
        ["hero_title", config.hero_title || defaultConfig.hero_title],
        ["hero_subtitle", config.hero_subtitle || defaultConfig.hero_subtitle],
        [
          "hero_cta_primary",
          config.hero_cta_primary || defaultConfig.hero_cta_primary,
        ],
        [
          "hero_cta_secondary",
          config.hero_cta_secondary || defaultConfig.hero_cta_secondary,
        ],
        ["about_title", config.about_title || defaultConfig.about_title],
        [
          "about_description",
          config.about_description || defaultConfig.about_description,
        ],
        ["contact_email", config.contact_email || defaultConfig.contact_email],
        ["contact_phone", config.contact_phone || defaultConfig.contact_phone],
        [
          "contact_address",
          config.contact_address || defaultConfig.contact_address,
        ],
      ]),
  });
}

// ==========================================
// TOAST NOTIFICATIONS
// ==========================================
export function showToast(message, type = 'success') {
  let toastContainer = document.getElementById('toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;

  toastContainer.appendChild(toast);

  // Trigger reflow
  void toast.offsetWidth;
  toast.classList.add('show');

  setTimeout(() => {
    toast.classList.remove('show');
    toast.addEventListener('transitionend', () => toast.remove());
  }, 3000);
}

// ==========================================
// EXPOSIÇÃO GLOBAL PARA O HTML (Módulos ES6)
// ==========================================
window.showToast = showToast;
window.scrollToSection = scrollToSection;
window.openProductModal = openProductModal;
window.closeProductModal = closeProductModal;
window.closeModalOnOverlay = closeModalOnOverlay;
window.openPdfModal = openPdfModal;
window.changeProductImage = changeProductImage;
window.selectProductImage = selectProductImage;
window.openBudgetModal = openBudgetModal;
window.closeBudgetModal = closeBudgetModal;
window.closeBudgetModalOnOverlay = closeBudgetModalOnOverlay;
window.toggleProductSelection = toggleProductSelection;
window.updateQuantity = updateQuantity;
window.setQuantity = setQuantity;
window.handleBudgetSubmit = handleBudgetSubmit;
window.updateBudgetCartBadge = updateBudgetCartBadge;
window.YtechApi = {
  getApiUrl,
  postJson,
  isTurnstileEnabled,
  renderTurnstileWidget,
  getTurnstileToken,
  resetTurnstileWidget,
};
